import cache from 'api/cache';
import CacheService from 'app/services/cacheService';

export const actionTypes = {
  set_cache: 'SET_CACHE',
  add: 'ADD_CACHE',
  addToUrl: 'ADD_TO_KEY_CACHE',
  set: 'SET_KEYS_UPDATED',
  delete: 'DELETE_CACHE',
  put: 'PUT_CACHE'
};

const initialState = { cache, status: '' };

const cacheReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.set_cache:
      CacheService.setKey(state.cache, action.payload.key, action.payload.data);
      return {
        ...state
      };
    case actionTypes.add:
      const { cache } = state;

      action.payload.keys.forEach(key =>
        CacheService.addDataToKey(cache, key, action.payload.data)
      );
      return {
        ...state,
        cache: Object.assign(
          Object.create(Object.getPrototypeOf(cache)),
          cache
        ),
        status: 'ADD_CACHE'
      };
    case actionTypes.addToUrl:
      CacheService.add(state.cache, action.payload.url, action.payload.data);
      return {
        ...state
      };
    // case actionTypes.add:
    //   CacheService.add(
    //     state.cache,
    //     action.payload.url,
    //     action.payload.data
    //   )
    //   return {
    //     ...state,
    //   };
    case actionTypes.delete:
      CacheService.delete(state.cache, action.payload.url, action.payload.id);
      return {
        ...state
      };
    case actionTypes.put:
      CacheService.update(state.cache, action.payload.url, action.payload.data);
      return {
        ...state
      };
    default:
      return state;
  }
};

export default cacheReducer;
